<template>
  <div class="d-flex justify-content-stretch">
    <button class="c-facets__showfacets" @click="showFacets = !showFacets">
      <i class="far fa-sliders-h"></i>
      <span class="font-weight-bold">
        <slot name="title">
          Filter products
        </slot>
      </span>
    </button>

    <transition name="slide">
      <div v-if="showFacets" key="drawer" class="c-facets__drawer">
        <div class="c-facets__drawer--title">
          <span class="font-weight-bold">
            <slot name="title">
              Filter products
            </slot>
          </span>

          <button
            class="c-facets__drawer--close"
            @click="showFacets = !showFacets"
          >
            <i class="far fa-times fa-lg"></i>
          </button>
        </div>

        <div class="c-facets__drawer--content">
          <reset-filters />

          <slot />
        </div>

        <div class="c-facets__drawer--footer">
          <button
            class="c-facets__drawer--showresult"
            @click="showFacets = !showFacets"
          >
            <slot name="view-results">
              View products
            </slot>
          </button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showFacets"
        key="overlay"
        class="c-facets__overlay"
        tabindex="0"
        @click="showFacets = !showFacets"
      ></div>
    </transition>
  </div>
</template>

<script>
import ResetFilters from './reset-filters.vue';

export default {
  name: 'MobileFacets',
  components: {
    ResetFilters
  },
  data() {
    return {
      showFacets: false
    };
  },
  created() {
    const onEscape = e => {
      if (this.showFacets && e.keyCode === 27) {
        this.showFacets = false;
      }
    };

    document.addEventListener('keydown', onEscape);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape);
    });
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-facets {
  &__showfacets {
    @include button-reset();

    background-color: $primary;
    flex-grow: 1;
    color: $white;
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    @include media-breakpoint-up(xl) {
      display: none;
    }
  }

  &__drawer {
    position: fixed;
    top: 0;
    left: 0;
    background-color: $white;
    width: 100%;
    height: 100%;
    box-shadow: $box-shadow;
    z-index: 100;
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      max-width: 375px;
    }

    &--title {
      background-color: $grey-900;
      color: $white;
      height: 65px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 20px;
      flex-shrink: 0;
    }

    &--close {
      @include button-reset();

      padding: 0 20px;
      align-self: stretch;
    }

    &--content {
      flex-grow: 1;
      overflow-y: scroll;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 35px;
    }

    &--footer {
      padding: 15px 20px;
      position: relative;
      box-shadow: 0px 0px 10px 0px rgba(128, 128, 128, 0.1);
    }

    &--showresult {
      @include button-reset();

      background-color: $primary;
      padding: 16px 0;
      color: $white;
      font-weight: 700;
      width: 100%;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 90;
    background-color: rgba($black, 0.6);
    cursor: pointer;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform $transition-default-duration $transition-default-timing;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-default-duration $transition-default-timing;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
